import ApiService from "@/core/services/ApiService";

const endpoints = {
    default: {
        user: "user",
        user_customer_group: "user/customer-group",
        user_address: "user/address",
        user_gender: "user/gender",
        user_label: "user/label",
        user_change_password: "user/change-password",
        auth_change_password: "auth/change-password",
        auth_update_profile: "auth/profile",
        search: "search",
        admin_notification: "notification",
        admin_notification_read: "notification/read",
        admin_notification_delete: "notification/delete",
        push_vapid: "push/vapid-key",
        push_subscribe: "push/subscribe",
        push_unsubscribe: "push/unsubscribe",
        user_self_login: "user/self-login",
        user_export: "user/export",
        localization_language: "localization/language",
        localization_tax: "localization/tax",
        localization_currency: "localization/currency",
        localization_country: "localization/country",
        localization_country_state: "localization/country/state",
        localization_country_city: "localization/country/city",
        tag: "tag",
        file: "file",
        file_move: "file/move",
        file_folder: "file/folder",
        file_folder_tree: "file/folder/tree",
        ecommerce_cart_link: "ecommerce/cart-link",
        ecommerce_abandoned_cart: "ecommerce/abandoned-cart",
        ecommerce_automation: "ecommerce/automation",
        ecommerce_automation_catalog: "ecommerce/automation/catalog",
        ecommerce_marketing_summary: "ecommerce/marketing/summary",
        ecommerce_marketing_campaign: "ecommerce/marketing/campaign",
        ecommerce_marketing_campaign_meta: "ecommerce/marketing/campaign/meta",
        ecommerce_marketing_campaign_preview: "ecommerce/marketing/campaign/preview-audience",
        ecommerce_order_draft: "ecommerce/order-draft",
        ecommerce_price_list: "ecommerce/price-list",
        ecommerce_app_installation: "ecommerce/app/installation",
        ecommerce_sales_channel: "ecommerce/sales-channel",
        ecommerce_product: "ecommerce/product",
        ecommerce_product_brand: "ecommerce/product/brand",
        ecommerce_product_category: "ecommerce/product/category",
        ecommerce_product_operation: "ecommerce/product/operation",
        ecommerce_product_group: "ecommerce/product/group",
        ecommerce_product_option_group: "ecommerce/product/option/group",
        ecommerce_product_detail_group: "ecommerce/product/detail/group",
        ecommerce_product_package_item: "ecommerce/product/package/item",
        ecommerce_product_personalization: "ecommerce/product/personalization",
        ecommerce_product_addon: "ecommerce/product/addon",
        ecommerce_product_trailer: "ecommerce/product/trailer",
        ecommerce_product_supplier: "ecommerce/product/supplier",
        ecommerce_product_unit: "ecommerce/product/unit",
        ecommerce_product_type: "ecommerce/product/type",
        ecommerce_product_variant_combination: "ecommerce/product/variant/combination",
        ecommerce_product_variant_combination_generate: "ecommerce/product/variant/combination/generate",
        ecommerce_product_variant_group: "ecommerce/product/variant/group",
        ecommerce_product_variant_item: "ecommerce/product/variant/item",
        ecommerce_product_attribute_set: "ecommerce/product/attribute/set",
        ecommerce_product_attribute: "ecommerce/product/attribute",
        ecommerce_product_attribute_option: "ecommerce/product/attribute/option",
        ecommerce_stock_warehouse: "ecommerce/stock/warehouse",
        ecommerce_stock_status: "ecommerce/stock/status",
        ecommerce_stock_adjustment: "ecommerce/stock/adjustment",
        ecommerce_stock_movement: "ecommerce/stock/movement",
        ecommerce_stock_purchase: "ecommerce/stock/purchase",
        ecommerce_stock_transfer: "ecommerce/stock/transfer",
        ecommerce_stock_count: "ecommerce/stock/count",
        ecommerce_product_index_raw: "ecommerce/product/index-raw",
        ecommerce_product_image_gallery: "ecommerce/product/image-gallery",
        module: "module",
        module_blog: "module/blog",
        module_blog_category: "module/blog/category",
        module_featured_product: "module/featured-product",
        module_featured_product_group: "module/featured-product/group",
        module_popup: "module/popup",
        module_popup_button: "module/popup/button",
        menu: "menu",
        menu_item: "menu/item",
        menu_item_reorder: "menu/item/reorder",
        link_manager: "link/manager",
        link_type: "link/type",
        system_variable: "system/variable",
        stream_provider: "stream/provider",
        stream_provider_account: "stream/provider/account",
        module_tracking_code: "module/tracking-code",
        module_tracking_code_location: "module/tracking-code/location",
        admin: "admin",
        admin_group: "admin/group",
        admin_group_endpoint: "admin/group/endpoint",
        theme: "theme",
        theme_setting: "theme/setting",
        theme_customize: "theme/customize",
        module_faq: "module/faq",
        module_faq_group: "module/faq/group",
        module_faq_category: "module/faq/category",
        module_form: "module/form",
        module_form_element: "module/form/element",
        module_form_element_type: "module/form/element/type",
        module_form_answer: "module/form/answer",
        module_slider_group: "module/slider/group",
        module_slider_item: "module/slider/item",
        module_slider_item_button: "module/slider/item/button",
        ecommerce_payment_method: "ecommerce/payment-method",
        ecommerce_payment_method_type: "ecommerce/payment-method/type",
        ecommerce_payment_method_sub_method: "ecommerce/payment-method/sub-method",
        ecommerce_order: "ecommerce/order",
        ecommerce_order_status: "ecommerce/order/status",
        ecommerce_order_export: "ecommerce/order/export",
        ecommerce_order_note: "ecommerce/order/note",
        ecommerce_order_payment_collection: "ecommerce/order/payment-collection",
        ecommerce_order_item_change_usage: "ecommerce/order/item/change-usage",
        ecommerce_order_item_change_usage_multi: "ecommerce/order/item/change-usage-multi",
        ecommerce_order_creator: "ecommerce/order/creator",
        ecommerce_order_creator_export: "ecommerce/order/creator/export",
        ecommerce_order_shipping: "ecommerce/order/shipping",
        ecommerce_order_shipping_waybill_preview: "ecommerce/order/shipping/waybill-preview",
        ecommerce_order_shipping_detail: "ecommerce/order/shipping/details",
        ecommerce_shipping_method: "ecommerce/shipping-method",
        ecommerce_shipping_method_rate: "ecommerce/shipping-method/rate",
        ecommerce_discount_coupon: "ecommerce/discount-coupon",
        ecommerce_discount_coupon_export: "ecommerce/discount-coupon/export/excel",
        ecommerce_discount_coupon_generate_code: "ecommerce/discount-coupon/generate-code",
        ecommerce_discount_coupon_creator: "ecommerce/discount-coupon/creator",
        ecommerce_gift_card: "ecommerce/gift-card",
        ecommerce_gift_card_generate_code: "ecommerce/gift-card/generate-code",
        ecommerce_campaign: "ecommerce/campaign",
        ecommerce_product_offer: "ecommerce/product-offer",
        ecommerce_invoice: "ecommerce/invoice",
        ecommerce_invoice_preview: "ecommerce/invoice/preview",
        ecommerce_invoice_show_legalized_pdf: "ecommerce/invoice/show-legalized-pdf",
        ecommerce_invoice_provider: "ecommerce/invoice/provider",
        ecommerce_invoice_provider_payment_method: "ecommerce/invoice/provider/payment-method",
        ecommerce_invoice_provider_util_stock_list: "ecommerce/invoice/provider/utils/stock-list",
        ecommerce_invoice_provider_util_product_list: "ecommerce/invoice/provider/utils/product-list",
        ecommerce_invoice_provider_util_is_support: "ecommerce/invoice/provider/utils/is-support",
        ecommerce_invoice_provider_product: "ecommerce/invoice/provider/product",
        ecommerce_invoice_provider_product_product_structure: "ecommerce/invoice/provider/product/product-structure",
        ecommerce_invoice_provider_product_create_product: "ecommerce/invoice/provider/product/create-product",

        // --- Postman koleksiyonuna göre eklenen route'lar ---
        // Admin / oturum
        admin_change_password: "admin/change-password",
        admin_group_duplicate: "admin/group/duplicate",
        history_login: "history/login",
        // Ürün
        ecommerce_product_category_tree: "ecommerce/product/category/tree",
        // Sipariş
        ecommerce_order_item_change_usage_multi_track: "ecommerce/order/item/change-usage-multi/track",
        // Dosya
        file_supported: "file/supported",
        // Link
        link_type_assigned: "link/type/assigned",
        // Form yanıtları
        module_form_answer_export_excel: "module/form/answer/export/excel",
        // Push bildirim
        module_push_notification: "module/push/notification",
        module_push_provider: "module/push/provider",
        module_push_provider_type: "module/push/provider/type",
        module_push_status: "module/push/status",
        // Bildirim (notification) yönetimi
        notification_item: "notification/item",
        notification_item_group: "notification/item/group",
        notification_item_sub_group: "notification/item/sub-group",
        notification_item_template: "notification/item/template",
        // Sayfa yönetimi
        page: "page",
        // Site ayarı
        site_setting: "site/setting",
        // SMS
        sms_check_phone: "sms/check/phone",
        sms_multi_send: "sms/multi-send",
        sms_multi_send_export: "sms/multi-send/export",
        sms_provider: "sms/provider",
        // İstatistik
        statistic_general: "statistic/general",
        statistic_product: "statistic/product",
        statistic_product_export_excel: "statistic/product/export/excel",
        statistic_product_specific: "statistic/product/specific",
        // Sistem ayarı
        system_setting: "system/setting",
        system_setting_register_element: "system/setting/register-element",
        system_setting_register_element_type: "system/setting/register-element/type",
        // Tema
        theme_customize_fetch: "theme/customize/fetch",
        // Tema bileşen (page builder) sistemi
        // page'e bağlı uçlar kod içinde `${base}/${page}/layout|blocks|publish` olarak kurulur
        theme_customize_component: "theme/customize/component",
        theme_customize_component_palette: "theme/customize/component/palette",
        theme_customize_component_render_block: "theme/customize/component/render-block",
        // Kullanıcı (müşteri) yardımcı uçları
        user_check_excel: "user/check/excel",
        user_check_plain: "user/check/plain",
        user_creator: "user/creator",
        user_creator_export: "user/creator/export",
        user_label_creator: "user/label/creator",
        user_label_creator_export: "user/label/creator/export",
    },
}

class EndpointService {
    static activeEndpoints = endpoints;
    static apiConfig = {
        default: process.env.VUE_APP_API_PATH,
        developer: process.env.VUE_APP_API_DEVELOPER_PATH,
    };

    static {
        this.setActiveEndpoints()
    }

    static get(endpointKey, groupKey = 'default') {
        ApiService.setBaseUrl(this.apiConfig[groupKey] ?? process.env.VUE_APP_API_URL);
        return (this.activeEndpoints[groupKey] && this.activeEndpoints[groupKey][endpointKey]) ? this.activeEndpoints[groupKey][endpointKey] : null;
    }

    static setActiveEndpoints(groupKey) {
        let groups = ['default', groupKey];

        for (let key in endpoints) {
            if (groups.includes(key)) {
                this.activeEndpoints[key] = endpoints[key];
            }
        }
    }

}

export default EndpointService;
